import { all } from "redux-saga/effects";
import authSaga from "../modules/Authentication/store/saga/auth.saga";
import settingSaga from "@/modules/Settings/store/saga/settings.saga";
import userSaga from "@/modules/Users/store/saga/users.saga";
import organizationSaga from "@/modules/Organizations/store/saga/organization.saga";

export default function* rootSaga() {
  yield all([authSaga(), settingSaga(), userSaga(), organizationSaga()]);
}
